/**
 * Shared MUI typography — matches Bootstrap $font-family-base (Ubuntu).
 */
export const appTypography = {
	fontFamily: '"Ubuntu", sans-serif',
	htmlFontSize: 16,
	h2: {
		fontSize: 21,
		fontWeight: 400,
	},
	body1: {
		fontWeight: 400,
	},
};
